import React from 'react';
import ReactDOM from 'react-dom/client';
import MedicalPWA from './MedicalPWA';
import './index.css';

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <MedicalPWA />
  </React.StrictMode>
);
